const Theme ={
    backgroundYellow:"#FBAF31"
}

export default Theme;